-1 != navigator.appVersion.indexOf("Win") &&
  jQuery("body").addClass("window-os"),
  navigator.platform.toUpperCase().indexOf("MAC") >= 0 &&
    jQuery("body").addClass("mac-os"),
  -1 != navigator.appVersion.indexOf("Linux") &&
    jQuery("body").addClass("linux-os"),
  -1 != navigator.appVersion.indexOf("Edge") && jQuery("body").addClass("edge");
var trident = !!navigator.userAgent.match(/Trident\/7.0/),
  net = !!navigator.userAgent.match(/.NET4.0E/),
  IE11 = trident && net,
  IEold = !!navigator.userAgent.match(/MSIE/i);
(IE11 || IEold) && jQuery("body").addClass("ie");
var ua = navigator.userAgent.toLowerCase();
-1 != ua.indexOf("safari") &&
  (ua.indexOf("chrome") > -1
    ? jQuery("body").addClass("chrome")
    : jQuery("body").addClass("safari"));
var FF = !(null == window.mozInnerScreenX);
FF
  ? jQuery("body").addClass("fire-fox")
  : jQuery("body").addClass("not-fire-fox"),
  $(window).scroll(function () {
    $(window).scrollTop() >= 50
      ? $("body").addClass("header-fixed")
      : $("body").removeClass("header-fixed");
  }),
  $('.scrolldown a[href*="#"]').on("click", function (e) {
    e.preventDefault(),
      $("html, body").animate(
        { scrollTop: $($(this).attr("href")).offset().top - 120 },
        500,
        "linear"
      );
  }),
  $(document).ready(function () {
    $(".preview-thumbnail-in a").removeClass("active"),
      $(".searchit").click(function () {
        $(this).addClass("search"), $(".search-form").show();
      }),
      $(".search-form a").click(function (e) {
        e.stopPropagation(),
          $(".search-form").hide(),
          $(".search-form").removeClass("search");
      }),
      $(document).ready(function () {
        $(".join-sec .product-box.container .description a").attr(
          "target",
          "_blank"
        );
      });
  });
